<template>
  <section id="about" role="region" aria-label="Forgot Password">
    <h2 class="lead mt-3">Forgot Your Password?</h2>
    <p class="text-muted">
      Please send an email to
      <a href="mailto:thetapedeckapp@gmail.com">thetapedeckapp@gmail.com</a>
    </p>
  </section>
</template>
